import React, { FC, HTMLAttributes } from 'react';
import { Widget } from 'components';
import classNames from 'classnames';
import { t } from 'utils';
import styles from './WebhooksStatistics.module.scss';

export interface IWebhooksStatistics extends HTMLAttributes<HTMLDivElement> {
  eventsStatistics: any;
  hookTypes?: any;
}

const WebhooksStatistics: FC<IWebhooksStatistics> = (props) => {
  const { className, eventsStatistics, hookTypes } = props;
  const entities = eventsStatistics
    ? Object.keys(eventsStatistics).filter((entity) => entity !== 'app')
    : [];
  const entitiesWithValues: any = entities.reduce((result, entity) => {
    const formattedEntity = entity.replace(/-/g, ' ');
    return {
      ...result,
      [`${formattedEntity}.created`]: eventsStatistics[entity].created,
      [`${formattedEntity}.updated`]: eventsStatistics[entity].updated,
      [`${formattedEntity}.deleted`]: eventsStatistics[entity].deleted,
    };
  }, {});
  const hookTypesWithData = hookTypes.filter((hookType: string) =>
    Object.keys(entitiesWithValues).includes(hookType)
  );
  const hasEventStatistics = !!eventsStatistics && hookTypesWithData.length > 0;

  const rootClassName = classNames(styles.root, className);

  return (
    <div className={rootClassName}>
      <h3 className={styles.title}>{t('webhook.statistics')}</h3>
      {hasEventStatistics && <p className={styles.text}>{t('webhook.statistics.description')}</p>}
      <div className={styles.grid}>
        {hasEventStatistics
          ? hookTypesWithData.map((eventStatistic: any) => (
              <Widget
                title={eventStatistic}
                data={entitiesWithValues[eventStatistic]}
                key={eventStatistic}
              />
            ))
          : t('webhook.statistics.noResults')}
      </div>
    </div>
  );
};

export default WebhooksStatistics;
